import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TwitchStoreActions from '../../../../Modules/Redux/Global/Twitch/TwitchStoreActions';
import AuthPageActions from '../../../../Modules/Redux/Pages/Auth/AuthPageActions';
import AuthPageSelectors from '../../../../Modules/Redux/Pages/Auth/AuthPageSelectors';
import { ReactComponent } from '../../../../Utils/Types';
import { Box } from '../../Components/Box/Box';
import { LoadingIndicator } from '../../Components/LoadingIndicator/LoadingIndicator';

export function AuthPage(): ReactComponent {
  const navigate = useNavigate();
  const isAuthenticated: boolean = useSelector(AuthPageSelectors.isAuthenticated);
  const areServicesReady: boolean = useSelector(AuthPageSelectors.areServicesReady);
  const dispatch = useDispatch();

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (isAuthenticated && areServicesReady) {
      navigate('/stream');
    }
  }, [isAuthenticated, areServicesReady]);

  function init(): void {
    const urlToken: string = getToken();
    dispatch(TwitchStoreActions.setTwitchToken(urlToken));
    dispatch(AuthPageActions.authenticate(urlToken));
  }

  function getToken(): string {
    const urlHash = require('urlhash');
    return urlHash().getUrlHashParameter('access_token');
  }

  return (
    <div className="items-center justify-center v-stack" style={{ minHeight: '100vh' }}>
      <Box>
        <div className="p-4">
          <LoadingIndicator />
        </div>
      </Box>
    </div>
  );
}
